module.exports = __webpack_public_path__ + "c11d253a870195c18296949e6f8fd5fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand.svg
// module id = YfJu
// module chunks = 0